export const VISITOR_FORM_URL = "https://dev-fmpapi.bluealgo.com/fmp/visitor-form";
